// Handle input fields changes

export const handleChangeFactory = (dispatch) => {
    return e => {
        console.log(e);
        const {name, value} = e.target;
        dispatch({ type: "CHANGE_VALUE", name: name, value: value });
    }
}
